<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Courses Recommender System -->
<tool-form formTitle="Rank Course Filter">
  <form (ngSubmit)="rankCoursesFormSubmit()" class="form-content">
    <!-- Display for Target Courses -->
    <div class="chip-list-wrapper">
      <!-- 'Fall' should be dynamic because it can be Spring or Summer -->
      <p>Target Courses (Inactive)</p>
      <!-- <mat-chip-list #chipList>
        <mat-chip class="course-mat-chip" *ngFor="let course of targetCourses" [selectable]="selectable"
          [removable]="removable" (removed)="removeTargetCourse(course)">
          {{ course }}
          <mat-icon *ngIf="removable" matChipRemove class="mat-chip-remove">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list> -->
    </div>

    <form [formGroup]="targetCoursesForm" (ngSubmit)="addTargetCourses()">
      <!-- Course Name Input -->
      <mat-form-field
        class="filter-form-field"
        appearance="fill"
        id="courseNumGrade-input"
      >
        <mat-label>Select course number</mat-label>
        <input
          type="text"
          placeholder="Example: MAC1105"
          matInput
          formControlName="course_code"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete">
          <cdk-virtual-scroll-viewport
            class="autocomplete-test-viewport"
            [ngStyle]="{ height: height }"
            itemSize="25"
          >
            <mat-option
              *cdkVirtualFor="let course of filteredCourses"
              [value]="course"
              class="autocomplete-item"
            >
              {{ course }}
            </mat-option>
          </cdk-virtual-scroll-viewport>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Add Course Button -->
      <tool-form-action-button text="Submit"></tool-form-action-button>
    </form>

    <!-- Display for Course History -->
    <div class="chip-list-wrapper">
      <!-- 'Fall' should be dynamic because it can be Spring or Summer -->
      <p>Course History (Inactive)</p>
      <!-- <mat-chip-list #chipList>
        <mat-chip class="course-mat-chip" *ngFor="let course of courseHistory" [selectable]="selectable"
          [removable]="removable" (removed)="removeCourseHistory(course)">
          {{ course }}
          <mat-icon *ngIf="removable" matChipRemove class="mat-chip-remove">
            cancel
          </mat-icon>
        </mat-chip>
      </mat-chip-list> -->
    </div>

    <form [formGroup]="courseHistoryForm" (ngSubmit)="addCourseHistory()">
      <!-- Course Name Input -->
      <mat-form-field
        class="filter-form-field"
        appearance="fill"
        id="courseNumGrade-input"
      >
        <mat-label>Select course number</mat-label>
        <input
          type="text"
          placeholder="Example: MAC1105"
          matInput
          formControlName="course_code"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete">
          <cdk-virtual-scroll-viewport
            class="autocomplete-test-viewport"
            [ngStyle]="{ height: height }"
            itemSize="25"
          >
            <mat-option
              *cdkVirtualFor="let course of filteredCourses"
              [value]="course"
              class="autocomplete-item"
            >
              {{ course }}
            </mat-option>
          </cdk-virtual-scroll-viewport>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Course Grade Input -->
      <mat-form-field
        class="filter-form-field"
        appearance="fill"
        id="courseNumGrade-input"
      >
        <mat-label>Select course grade</mat-label>
        <mat-select
          name="course_grade"
          formControlName="course_grade"
          (selectionChange)="checkDropdown($event)"
        >
          <mat-option value="A">A</mat-option>
          <mat-option value="A-">A-</mat-option>
          <mat-option value="B+">B+</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="B-">B-</mat-option>
          <mat-option value="C+">C+</mat-option>
          <mat-option value="C">C</mat-option>
          <mat-option value="C-">C-</mat-option>
          <mat-option value="D+">D+</mat-option>
          <mat-option value="D">D</mat-option>
          <mat-option value="F">F</mat-option>
          <mat-option value="W">W</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Add Course Button -->
      <tool-form-action-button
        text="Add Course"
        type="button"
        [disabled]="emptyInput"
      ></tool-form-action-button>
    </form>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="disabledSubmitButton()"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
